import axios from '../index';

export const requestQuestionnaireResponse = ({ patientId }) =>
  axios.get(`/fhir/QuestionnaireResponse/${patientId}`);
